import { useState } from "react";
import StepOne from "./StepOne";
import FinalStep from "./FinalStep";
import "./style.scss";

const FormSelector = (props) => {
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    url: "",
    name: "",
    value: "",
  });

  const formName = formData.name;

  const enableNextStep = () => {
    const button = document.querySelector(".FormSelector__button");
    if (button.classList.contains("button--disabled")) button.classList.remove("button--disabled");
  };

  const disableNextStep = () => {
    const button = document.querySelector(".FormSelector__button");
    button.classList.add("button--disabled");
  };

  const prevStep = () => {
    setStep(1);
  };

  const nextStep = () => {
    setStep(2);
  };

  const handleOnchageRadio = (e) => {
    const { value } = e.target;

    let formName;
    switch (value) {
      case "new":
        formName = "DS-11";
        break;
      case "renewal":
        formName = "DS-82";
        break;
      case "lost-stolen":
        formName = "DS-64";
        break;
      default:
        formName = "";
    }

    setFormData((prevState) => ({
      ...prevState,
      url: `/${value}`,
      name: formName,
      value: value,
    }));
  };

  const handlePrevStep = () => {
    prevStep();
  };

  const handleOnSubmit = () => {
    window.location.href = formData.url;
  };

  return (
    <form
      onSubmit={handleOnSubmit}
      className="FormSelector__form">
      <div
        className={`Card FormSelector FormSelector-template-${props.template} FormSelector--step${step}`}>
        {step === 1 ? (
          <StepOne
            template={props.template}
            data={props.stepOne}
            nextStep={nextStep}
            disableNextStep={disableNextStep}
            enableNextStep={enableNextStep}
            handleOnchageRadio={handleOnchageRadio}
            formData={formData}
          />
        ) : (
          <FinalStep
            data={props.finalStep[formName]}
            handlePrevStep={handlePrevStep}
            handleOnSubmit={handleOnSubmit}
            formData={formData}
          />
        )}
      </div>
    </form>
  );
};

export default FormSelector;
